import { useRoutes } from 'react-router-dom';
import { Suspense, useMemo } from 'react';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import SuspenseLoader from 'src/components/SuspenseLoader';

import 'react-notifications/lib/notifications.css';
import ThemeProvider from './theme/ThemeProvider';
import { CssBaseline } from '@mui/material';

import { Provider } from 'react-redux';
import { store } from './app/store';

import 'react-phone-input-2/lib/material.css';

import { AuthProvider, useAuth } from './auth/AuthContext';
import RouteSplitter from './router';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const AppContent = () => {
  const { user, loading } = useAuth();

  const split_routes = useMemo(() => RouteSplitter(user?.role), [user?.role]);

  const content = useRoutes(split_routes);

  if (loading) {
    return null;
  }

  return content;
};

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <CssBaseline />
            <AppContent />
          </LocalizationProvider>
        </ThemeProvider>
      </AuthProvider>
    </Provider>
  );
};

export default App;
